import { render, staticRenderFns } from "./tenantConfigMobile.vue?vue&type=template&id=79d30ccc&scoped=true&"
import script from "./tenantConfigMobile.vue?vue&type=script&lang=js&"
export * from "./tenantConfigMobile.vue?vue&type=script&lang=js&"
import style0 from "./tenantConfigMobile.vue?vue&type=style&index=0&id=79d30ccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d30ccc",
  null
  
)

export default component.exports